import {useMutation} from '@apollo/react-hooks';

import type {
    UpdateField as UpdateFieldMutation,
    UpdateFieldVariables as UpdateFieldMutationVariables,
    FormFieldUpdateInput,
} from 'nutshell-graphql-types';

import WF_FIELD_FRAGMENT from '../graphql/fragments/wf-field-fragment.graphql';
import FIELD_UPDATE from '../graphql/mutations/update-field.graphql';

export function useFieldUpdate(): (arg1: FormFieldUpdateInput) => Promise<any> {
    const [updateField] = useMutation<UpdateFieldMutation, UpdateFieldMutationVariables>(
        FIELD_UPDATE
    );

    return (input: FormFieldUpdateInput) => {
        return updateField({
            variables: {input},
            update: (proxy, mutationResults) => {
                // Read the data from our cache for this fragment.
                const fieldFragment = proxy.readFragment({
                    id: input.field.id,
                    fragmentName: 'WfFieldFragment',
                    fragment: WF_FIELD_FRAGMENT,
                });

                if (fieldFragment) {
                    const updatedField =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.formFieldUpdate &&
                        mutationResults.data.formFieldUpdate.field;

                    if (!updatedField) return;

                    proxy.writeFragment({
                        id: input.field.id,
                        fragmentName: 'WfFieldFragment',
                        fragment: WF_FIELD_FRAGMENT,
                        data: updatedField,
                    });
                }
            },
        });
    };
}
